<template>
  <div class="need">
    <div class="container">
      <div v-if="development"><h3><span class="badge badge-danger">ACHTUNG: System noch nicht in Betrieb! Morgen wieder kommen.</span></h3></div>
      <div class="jumbotron shadow">
        <h1 class="display-4">need2have.org - for Covid19</h1>
        <p class="lead">Bestellplattform - Veröffentliche, was du brauchst oder was du hast und anbieten möchtest.</p>
        <small>Produzenten tragen bitte ihren aktuellen Lagerstand bzw. die Größe ihrer täglichen Produktion ein.</small>
      </div>
    </div>
    <b-form inline @reset="onReset" @submit="handleFormSumbission($event)" id="form">
    <div class="container">
      <div class="card shadow">
        <div class="card-header badge-dark">
          Deine Kontaktdaten
        </div>
        <div class="card-body mx-1">
            <div class="row">
                <label class="col-1" for="inline-form-input-email">Email:</label>
                  <b-form-input
                    class="col-7"
                    id="input-email"
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="E-Mail angeben"
                  ></b-form-input>
                
                <label class="col-1" for="inline-form-input-tel">Tel:</label>
                  <b-form-input
                    class="col-3"
                    id="input-tel"
                    v-model="form.tel"
                    type="text"
                    required
                    placeholder="Telefonnummer angeben"
                  ></b-form-input>
                
            </div>

            <div class="row mt-2">

              <label class="col-1" for="inline-form-input-name">Name:</label>
                <b-form-input
                  class="col-4"
                  id="input-name"
                  v-model="form.name"
                  type="text"
                  required
                  placeholder="Vorname und Nachname angeben"
                ></b-form-input>

              <label class="col-1" for="inline-form-input-address">Adresse:</label>
                <b-form-input
                  class="col-6"
                  id="input-address"
                  v-model="form.address"
                  type="text"
                  required
                  placeholder="Adresse inkl. Land angeben"
                ></b-form-input>

            </div>

            <div class="row mt-2">

                <label class="col-1" for="inline-form-input-zip">PLZ:</label>
                  <b-form-input 
                    class="col-1"
                    id="input-zip"
                    v-model="form.zip"
                    type="text"
                    required
                    placeholder="Postleitzahl angeben"
                  ></b-form-input>

                  <label class="col-1" for="inline-form-input-city">Ort:</label>
                    <b-form-input
                      class="col-6"
                      id="input-city"
                      v-model="form.city"
                      type="text"
                      required
                      placeholder="Ort angeben"
                    ></b-form-input>

                    <label class="col-1" for="inline-form-input-country">Land:</label>
                      <b-form-input
                        class="col-2"
                        id="input-country"
                        v-model="form.country"
                        type="text"
                        required
                        placeholder="Land angeben"
                      ></b-form-input>

            </div>    

            <div class="row mt-2">

              <label class="col-1" for="inline-form-input-datapolicyaccepted"></label>
                <b-form-checkbox
                  class="text-left"
                  id="input-datapolicyaccepted"
                  v-model="form.datapolicyaccepted"
                  name="input-datapolicyaccepted"
                  required
                  value="accepted"
                  unchecked-value="not_accepted"
                >Ich stimme einer Veröffentlichung meiner Daten zu.</b-form-checkbox>

            </div>
               
        </div>
      </div>
    </div>


    <div class="container mt-4">
      <div class="row">
        <div class="col">
          <div class="card shadow" v-bind:class="{ 'border-warning': isHave(), 'border-info': isNeed() }">
            <div class="card-header" v-bind:class="{ 'bg-warning': isHave(), 'bg-info': isNeed() }">
                <b-form-group label="" class="row" :v-on:click="setTypeState()">
                  <b-form-radio
                    class="col-6"
                    v-model="form.type" 
                    name="type-radio-button" 
                    required
                    button 
                    button-variant="outline-info"
                    value="need"
                    inline
                  >
                     <b>Ich brauche!</b>
                  </b-form-radio>
                  <b-form-radio 
                    class="col-6"
                    v-model="form.type" 
                    name="type-radio-button"
                    required
                    button 
                    button-variant="outline-warning"
                    value="have"
                    inline
                  >
                    <b>Ich habe anzubieten!</b>
                  </b-form-radio>
                </b-form-group>
            </div>
            <div class="card-body mx-1">
              <div class="row col-12">                
                <ul class="pl-0 list-unstyled d-flex flex-wrap">
                  <li v-for="itemType in itemTypeList" :key="itemType">  
                    <b-button :active="(itemTypeSelected == itemType)" :pressed="(itemTypeSelected == itemType)" @click="toggleItem(itemType)" class="m-1" variant="outline-dark">{{ itemType }}</b-button>
                  </li>
                </ul>       
                <div class="blockquote text-center w-100 mt-0"><span class="badge badge-danger">Vorhandene Produkt-Bezeichnungen benutzen (anklicken). Sonst seid ihr nicht in der Suche!</span></div>
              </div>
              <div class="row col-12">
                <label class="col-1" for="inline-form-input-item">Was:</label>
                <b-form-input
                  class="col-6"
                  id="input-item"
                  v-model="form.item"
                  type="text"
                  required
                  placeholder="Bezeichnung eingeben."
                ></b-form-input>
                <label class="col-1" for="inline-form-input-amount">Wieviel:</label>
                <b-form-input
                  class="col-4"
                  id="input-amount"
                  v-model="form.amount"
                  type="number"
                  required
                  placeholder="Anzahl eingeben."
                ></b-form-input>
              </div>
              <div class="row mt-2 col-12">
                <div class="col-3"></div>
                <div class="col-3" v-if="isNeed()">
                  <b-button id="submit-need" name="submit-need" class="w-100 btn-info" type="submit" variant="info">Gesuch abschicken</b-button>
                </div>
                <b-button class="col-3" type="reset" variant="danger">Reset</b-button>
                <div class="col-3" v-if="isHave()">
                  <b-button id="submit-have" name="submit-have" class="w-100 btn-info" type="submit" variant="warning">Angebot abschicken</b-button>
                </div>
                <div class="col-3"></div>
              </div>
              <div class="row mt-2 col-12 py-2">
                <b-alert
                  class="col-12"
                  :show="dismissCountDown"
                  dismissible
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  variant="success"
                >
                  Erfolgreich abgeschickt. Anfrage/Angebot erscheint in der Liste unten!
                </b-alert>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>

  </b-form>

    <div class="container mt-3 mb-5">
      <div class="row">
        <div class="col">
           <b-card class="mt-3 shadow" header="Suchanfrage" border-variant="info" header-bg-variant="info" header-text-variant="white">
             <ul id="needs-list" class="pl-0">
               <li is="Item" v-for="item in needsReversed" v-bind:key="item.uuid" v-bind:item="item"></li>
             </ul> 
           </b-card>   
        </div>
        <div class="col">
           <b-card class="mt-3 shadow" header="Angebote" border-variant="warning" header-bg-variant="warning">
             <ul id="needs-list" class="pl-0">
               <li is="Item" v-for="item in havesReversed" v-bind:key="item.uuid" v-bind:item="item"></li>
             </ul> 
           </b-card>   
        </div>
      </div>
    </div>

    <div class="container mt-3 mb-5">
      <div class="row">
        <div class="col text-center">
          <small>Impressum: Herausgeber und Medieninhaber Markus Kienast, Bürgerliste GERMS, Kreuzberg 298, 3920 Groß Gerungs, Austria | Dieses VMS System ist Roger Andel gewidmet.</small>
        </div>
      </div>      
    </div>

  </div>
</template>

<script>
import { uuid } from 'vue-uuid';
import Item from './Item';

export default {
  components: {
    Item,
  },
  computed: {
    actionBG: function() {
      return this.actionTypeBG 
    },
    actionBorder: function() {
      return this.actionTypeBorder 
    }
  },
  watch: {
    actionType: function (val) {
      switch(val.type) {
        case 'need':
          this.actionTypeBG = 'bg-info'
          this.actionTypeBorder = 'border-info'
          break;
        case 'have':
          this.actionTypeBG = 'bg-warning'
          this.actionTypeBorder = 'border-warning'
          break;
        default:
          this.actionTypeBG = ''
          this.actionTypeBorder = ''
      }
      console.log(this.form.type)
    },
    itemTypeSelected: function (val) {
      this.needsReversed = this.filterByItemType(this.needs, val)
      this.havesReversed = this.filterByItemType(this.haves, val)
    },
    needsMessageReceived: function (val) {
      this.needs = [...val.payload]
      this.needsReversed = this.filterByItemType(this.needs, this.itemTypeSelected)
      this.itemTypeList = this.produceItemTypeList(this.needs)
      console.log(JSON.stringify(this.itemTypeList))
    },
    havesMessageReceived: function (val) {
      this.haves = [...val.payload]
      this.havesReversed = this.filterByItemType(this.haves, this.itemTypeSelected)
      this.itemTypeList = this.produceItemTypeList(this.haves)
      console.log(JSON.stringify(this.itemTypeList))
    },
  },
  data () {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      development: false,
      actionType: '',
      actionTypeBG: '',
      actionTypeBorder: '',
      itemTypeList: [
        'FFP3 Masken',
        'FFP2 Masken',
        'FFP1 Masken',
        'NMS Masken medizinisch',
        'NMS Masken Eigenproduktion',
        'F9 Masken',
        'Gesichtsfeldschutz',
        'OP Hauben',
        'Schutzanzüge',
        'Latexhandschuhe',
        'F9 Filtermatte 25x35cm',
        'F9 Filtermatte m²'        
      ],
      itemTypeSelected: '',
      form: {
        email: '',
        tel: '',
        name: '',
        address: '',
        zip: '',
        city: '',
        country: '',
        datapolicyaccepted: 'not_accepted',
        item: '',
        amount: null,
        uuid: ''
      },
      show: true,
      needs: [],
      haves: [],
      needsReversed: [],
      havesReversed: [],
      needsMessageReceived: {},
      havesMessageReceived: {},
      test: {
        "email": "mark@germs.at",
        "tel": "+4369918084401",
        "name": "Markus Kienast",
        "address": "Kreuzberg 298",
        "zip": "3920",
        "city": "Gross Gerungs",
        "country": "Austria",
        "type": "need",
        "item": "FFP3 Masken",
        "amount": "22",
        "uuid": "af6b35eb-9ab1-42a1-b879-e58ff354e813",
        "created_at": "2020-04-03T19:11:40.128Z",
        "created_ms": 1585941100128
    }
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    isHave() {
      return (this.form.type == 'have')
    },
    isNeed() {
      return (this.form.type == 'need')
    },
    setTypeState(){
      this.actionType = this.form.type
      console.log('nothing to do: ' + this.form.type )
    },
    produceItemTypeList(list) {
      return _.sortBy(_.compact(_.uniq(_.concat([...this.itemTypeList], _.flatMap(_.uniqBy([...list], 'item'), function(v) { return v.item })))))
    },
    filterByItemType(list, val) {
      if (val == '') {
        return _.reverse([...list])
      } else {
        return _.orderBy(_.filter([...list], {'item': val}), ['created_ms'], ['desc'])
      }      
    },
    getButtonName(evt) {
      evt.preventDefault()
      //console.log("getButtonName" + event);
    },
    handleFormSumbission(evt) {
      evt.preventDefault()
      var date = new Date();
      console.log(evt.target.name)
      //var type = (evt.target.id == 'submit-need') ? 'need' : 'have'
      var obj = {
        topic: this.$namespace + '/' + this.form.type,
        service_uuid: '34098bb0-0752-4aa8-bed4-c04aa02c6f36',
        service_name: 'webservice',
        service_host: 'need2have.org',
        created_at: date.toISOString(),
        created_ms: date.valueOf(),
        payload: Object.assign({}, this.form, {
          created_at: date.toISOString(), 
          created_ms: date.valueOf(),
          uuid: uuid.v4()
        })
      }
      this.$mqtt.publish(obj.topic, JSON.stringify(obj), {
        retain: false,
        properties: {
        }
      });
      this.form.item = ''
      this.form.amount = null
      this.showAlert();
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.tel = ''
      this.form.name = ''
      this.form.address = ''
      this.form.zip = ''
      this.form.city = ''
      this.form.country = ''
      this.form.item = ''
      this.form.amount = null
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.itemTypeSelected = '';
      this.$nextTick(() => {
        this.show = true
      })
    },
    toggleItem (itemname) {
      if (this.form.item == itemname) {
        this.form.item = '';
        this.itemTypeSelected = '';
      } else {
        this.form.item = itemname;
        this.itemTypeSelected = itemname;
      }
    },
    publish1 () {
      this.$mqtt.publish('corona/test/publish1', 'message to Sub1')
    },
    publish2 () {
      this.$mqtt.publish('corona/test/publish2', 'message to Sub2')
    },
    geo () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            this.$mqtt.publish('corona/test/geo', {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            })
          })
      } else {
        this.$mqtt.publish('corona/test/geo', "geo not available")
      }
    },
  },
  mqtt: {
    'corona/need' (data, topic) {
      console.log(topic + ': ' + data)
      //this.needs.push(JSON.parse(data).payload);
    },
    'corona/have' (data, topic) {
      console.log(topic + ': ' + data)
      //this.haves.push(JSON.parse(data).payload);
    },
    'corona/needs' (data, topic) {
      this.needsMessageReceived = JSON.parse(data)
      console.log(topic + ': ' + data)
    },
    'corona/haves' (data, topic) {
      this.havesMessageReceived = JSON.parse(data)
      console.log(topic + ': ' + data)
    }
  }
}




</script>